import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPrimaryInsuranceList } from '../../utilities/api';

export const fetchPrimaryInsuranceCarrier = createAsyncThunk(
  'users/fetchPrimaryInsuranceCarrier', fetchPrimaryInsuranceList
);

const initialState = {
  isLoading: false,
  primaryInsuranceValues: [],
  policyDetails: {
    primaryInsurance: {
      value: '',
      isValid: true,
      isRequired: true
    },
    planType: {
      value: '',
      isValid: true,
      isRequired: true
    },
    policyId: {
      value: '',
      isValid: true,
      isRequired: true
    },
    insuranceType: {
      value: '',
      isValid: true,
      isRequired: true
    },
    telephoneNumber: {
      value: '',
      isValid: true,
      isRequired: true
    }
  },
  subscriberDetails: {
    subscriberName: {
      value: '',
      isValid: true,
      isRequired: true
    },
    groupNumber: {
      value: '',
      isValid: true,
      isRequired: true
    },
    subscriberDob: {
      value: '',
      isValid: true,
      isRequired: true
    }
  },
  insuranceInfo: {
    medicareSupplement: false,
    secondaryInsurance: false,
    medicarePart: false,
    secondaryInsuranceCarrier: {
      value: '',
      isValid: true,
      isRequired: false
    }
  }
}

const insuranceSlice = createSlice({
  name: 'insuranceTab',
  initialState,
  reducers: {
    resetPolicyDetails: (state) => {
      state.policyDetails = initialState.policyDetails;
    },
    resetSubscriberDetails: (state) => {
      state.subscriberDetails = initialState.subscriberDetails;
    },
    resetInsuranceInfo: (state) => {
      state.insuranceInfo = initialState.insuranceInfo;
    },
  },
  extraReducers: (builder) => {
      builder
          .addCase(fetchPrimaryInsuranceCarrier.pending, (state, action) => {
              state.isLoading = true;
          })
          .addCase(fetchPrimaryInsuranceCarrier.fulfilled, (state, action) => {
            state.primaryInsuranceValues = action.payload.pxResults;
            state.isLoading = false;
          })
          .addCase(fetchPrimaryInsuranceCarrier.rejected, (state, action) => {
              state.isLoading = false;
          })
  },
});

export default insuranceSlice.reducer;

